import { c, classy, m } from '@onfido/castor';
import { useField } from '@onfido/castor-react';
import React from 'react';
import { withRef } from '../../utils';
let idCount = 0;
export const Input = withRef(function Input({ id = `castor_input_${++idCount}`, type = 'text', invalid, className, ...restProps }, ref) {
    const { disabled, touched } = useField();
    return (React.createElement("input", { disabled: disabled, ...restProps, ref: ref, id: id, type: type, className: classy(c('input'), m({ invalid, touched }), className) }));
});
//# sourceMappingURL=input.js.map